import React, { FC, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { FeatureLayer } from "@evergis/react";

import { getCurrentFeatureId } from "../../ducks/selectFeatures/selectors";
import { featureId } from "../../ducks/selectFeatures/utils";
import { getTableSelectedFeature } from "../../ducks/table/selectors";
import { useProjectLayersLength } from "../../hooks/project/useProjectLayers";
import { useCreateFeature } from "../../evergis/core/feature/createFeature";
import { useSelectedFeaturesEffect } from "./hooks/useSelectedFeaturesEffect";
import { useFeatureToShow } from "./hooks/useFeatureToShow";
import { useSelectFeaturesInitialized } from "../../hooks/selectFeatures/useSelectFeaturesInitialized";

export const FeatureSelector: FC = () => {
  const tableSelectedFeature = useSelector(getTableSelectedFeature);
  const currentFeatureId = useSelector(getCurrentFeatureId);
  const zIndex = useProjectLayersLength();
  const createFeature = useCreateFeature();
  const { feature: featureToShow } = useFeatureToShow();
  const [, setSelectFeaturesInitialized] = useSelectFeaturesInitialized();

  useSelectedFeaturesEffect();

  useLayoutEffect(() => {
    setSelectFeaturesInitialized(true);
  }, []);

  return (
    <FeatureLayer
      features={
        featureToShow
          ? [
              createFeature(
                featureToShow,
                tableSelectedFeature ? featureId({ id: tableSelectedFeature.id }) : currentFeatureId,
              ),
            ]
          : []
      }
      zIndex={zIndex + 1}
    />
  );
};
